// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__2v3hf","container__top":"Details_container__top__Kg-4H","container__bottom":"Details_container__bottom__2eWfo"};